import Model from './Model';

export default class FileType extends Model {
    code;
    name;

    static apiPath() {
        return 'trajectory-file-types';
    }
}



// WEBPACK FOOTER //
// ./src/models/FileType.js